import {
  PREDES_TRANSACTIONS_RELEASE_REQUEST,
  PREDES_TRANSACTIONS_RELEASE_SUCCESS,
  PREDES_TRANSACTIONS_RELEASE_FAILURE,
  PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST,
  PREDES_TRANSACTIONS_BULK_RELEASE_SUCCESS,
  PREDES_TRANSACTIONS_BULK_RELEASE_FAILURE,
} from './types/PredesTransactionsReleaseActionsTypes';

export function postPredesTransactionsReleaseRequestActionCreator(context,
  selectedArrivalDateTime,
  selectedComments,
  selectedDepartureDateTime,
  selectedTransactionId) {
  return {
    type: PREDES_TRANSACTIONS_RELEASE_REQUEST,
    payload: {
      appContext: context,
      params: {
        arrivalDateTime: selectedArrivalDateTime,
        comment: selectedComments,
        departureDateTime: selectedDepartureDateTime,
        transactionIds: selectedTransactionId,
      },
    },
  };
}

export function postPredesTransactionsReleaseSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_RELEASE_SUCCESS,
    payload: data,
  };
}

export function postPredesTransactionsReleaseFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_RELEASE_FAILURE,
    payload: error,
    error: true,
  };
}

export function postPredesTransactionsBulkReleaseRequestActionCreator(context,
  selectedTransactionId) {
  return {
    type: PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST,
    payload: {
      appContext: context,
      params: {
        transactionIds: selectedTransactionId,
      },
    },
  };
}

export function postPredesTransactionsBulkReleaseSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_BULK_RELEASE_SUCCESS,
    payload: data,
  };
}

export function postPredesTransactionsBulkReleaseFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_BULK_RELEASE_FAILURE,
    payload: error,
    error: true,
  };
}
